import React from 'react'
import styled from 'styled-components'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useActiveWeb3React } from '../../../hooks/web3'
import { shortenAddress } from '../../../lib/web3/utils'
import Typography from '@mui/material/Typography'
import WalletIcon from './icon'

const AccountAddress = ({ textSize = 'h5', short }) => {
  const { account } = useActiveWeb3React()
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const charsToShowAtEnd = isMobile ? 3 : 4
  return (
    <Container>
      <WalletIcon />
      {short ? (
        <>
          {account && (
            <Typography variant={textSize}>
              {shortenAddress(account, isMobile ? 3 : 4)}
            </Typography>
          )}
        </>
      ) : (
        <>
          {account && (
            <Typography
              noWrap
              align='center'
              variant={textSize}
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }}
            >
              {account.substring(0, account.length - charsToShowAtEnd)}
            </Typography>
          )}
          {account && (
            <Typography variant={textSize} style={{ flexShrink: 0 }}>
              {account.substring(account.length - charsToShowAtEnd)}
            </Typography>
          )}
        </>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  min-width: 0;
`

export default AccountAddress
